<template>
  <div class="header_pc">
    <img
      class="header_pc__logo"
      src="../../assets/img/img-header-logo.png">
    <BtnIntroduction
      v-if="lang.key === 'JP'"
      class="header_pc__introduction"/>
    <BtnNews class="header_pc__news"/>
    <BtnTwitter class="header_pc__twitter"/>
    <BtnFacebook class="header_pc__facebook"/>
    <BtnLanguage class="header_pc__language"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BtnIntroduction from '@/components/atoms/BtnIntroduction'
import BtnNews from '@/components/atoms/BtnNews'
import BtnTwitter from '@/components/atoms/BtnTwitter'
import BtnFacebook from '@/components/atoms/BtnFacebook'
import BtnLanguage from '@/components/atoms/BtnLanguage'

export default {
  name: 'HeaderPc',
  components: {
    mapGetters,
    BtnIntroduction,
    BtnNews,
    BtnTwitter,
    BtnFacebook,
    BtnLanguage
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['textData', 'lang'])
  },
  methods: {
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="postcss" scoped>
  .header_pc {
    display: flex;
    position: relative;
    width: 100vw;
    min-width: 960px;
    height: 80px;
    color: #FFFFFF;
    background: #CC3454;
    padding: 0 35px;
    box-sizing: border-box;
    &__logo {
      margin: 23px 30px 0 0;
      width: 206px;
      height: 34px;
    }
    &__introduction {
      width: 240px;
      height: 35px;
      margin: 22px 20px 0 0;
      color: #CC3454;
      background: #FFFFFF;
      border-radius: 24px;
    }
    &__news {
      margin: 28px 0;
    }
    &__twitter {
      position: absolute;
      top: 30px;
      right: 210px;;
    }
    &__facebook {
      position: absolute;
      top: 30px;
      right: 125px;
      font-size: 0;
    }
    &__language {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      margin: 15px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/HeaderPc.vue